"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueSame = exports.valueIsEmail = exports.valueIsPhone = exports.valueMaxLength = exports.valueMinLength = exports.valueLength = exports.valueNotNumber = exports.valueNumberUInt = exports.valueNumberInt = exports.valueNumberMin = exports.valueNumberMax = exports.valueIsNumber = exports.valueRequired = exports.isNumber = exports.localize = exports.messages = exports.validEmailReg = exports.validPhoneReg = void 0;
const gs = require("../index");
exports.validPhoneReg = '^[0-9]+$'; //'(7|8|38|37|07)[0-9]{3}[0-9]{7}'
exports.validEmailReg = '.+@.+\..+'; //'(7|8|38|37|07)[0-9]{3}[0-9]{7}'
const messages_ru = {
    notFoundSameField: "Не найдено поле для сравнения!",
    noValue: "Введите значение!",
    noSelectedValue: "Укажите значение!",
    noNumber: "Введите число!",
    noIntNumber: "Нужно ввести целое число!",
    noUIntNumber: "Нужно ввести целое положительное число!",
    noPhone: "Введите номер телефона в нужном формате!",
    noEmail: "Введите email в нужном формате!",
    noSame: "Введите одинаковое значение!",
    noFoto: "Загрузите фото!",
    maxValue: "Максимальное значение {arg0}!",
    minValue: "Минимальное значение {arg0}!",
    notOnlyNumber: "Введите не только цифры!",
    fixCountChars: "Нужно ввести {arg0} символа!",
    fixCountElements: "Нужно {arg0} элементов!",
    noMoreChars: "Не более {arg0} символов!",
    noMoreElements: "Не более {arg0} элементов!",
    noLessChars: "Не менее {arg0} символов!",
    noLessElements: "Не менее {arg0} элементов!",
};
const messages_en = {
    notFoundSameField: "Comparison field not found!",
    noValue: "Please enter a value!",
    noSelectedValue: "Please select a value!",
    noNumber: "Please enter a number!",
    noIntNumber: "Please enter an integer!",
    noUIntNumber: "Please enter a positive integer!",
    noPhone: "Please enter a phone number in the correct format!",
    noEmail: "Please enter an email in the correct format!",
    noSame: "Please enter the same value!",
    noFoto: "Please upload a photo!",
    maxValue: "Maximum value is {arg0}!",
    minValue: "Minimum value is {arg0}!",
    notOnlyNumber: "Please enter more than just digits!",
    fixCountChars: "You need to enter {arg0} characters!",
    fixCountElements: "You need {arg0} elements!",
    noMoreChars: "No more than {arg0} characters!",
    noMoreElements: "No more than {arg0} elements!",
    noLessChars: "At least {arg0} characters!",
    noLessElements: "At least {arg0} elements!",
};
exports.messages = messages_ru;
function localize(lang) {
    if (lang == "ru")
        exports.messages = messages_ru;
    else
        exports.messages = messages_en;
}
exports.localize = localize;
exports.messages = messages_ru;
function replace(str, value) { return str.replace("{arg0}", value + ""); }
function _noValue(wr) {
    if (!wr)
        return true;
    if (wr.value === undefined || wr.value === null || wr.value === "")
        return true;
    return (!wr.value);
}
function isNumber(val) { const num = parseFloat(val); return (!isNaN(num) && isFinite(num)); }
exports.isNumber = isNumber;
function valueRequired(wr) {
    if (!wr)
        return exports.messages.noValue;
    const checkBox = gs.def.toType(wr, gs.CheckBox);
    let imageEditor;
    let htmlContentEditor;
    if (checkBox) {
        if (!checkBox.value)
            return exports.messages.noSelectedValue;
        return true;
    }
    if (imageEditor) {
        if (!imageEditor.valid())
            return exports.messages.noFoto;
        return true;
    }
    if (htmlContentEditor) {
        const htmlVal = htmlContentEditor.getHtml();
        if (htmlVal === '<br>' || htmlVal === '') {
            return exports.messages.noValue;
        }
        return true;
    }
    if ((wr.value === undefined) || (!wr.value))
        return exports.messages.noValue;
    return true;
}
exports.valueRequired = valueRequired;
function valueIsNumber(wr) {
    if (!wr.value)
        return exports.messages.noNumber;
    wr.value = wr.value.replace(/[,]/g, '.');
    const n = parseFloat(wr.value);
    if (!(!isNaN(n) && isFinite(n))) {
        wr.value = wr.value.replace(/[^-.,\d]/g, '');
        return exports.messages.noNumber;
    }
    return true;
}
exports.valueIsNumber = valueIsNumber;
function valueNumberMax(wr, max) {
    const valid = valueIsNumber(wr);
    if (typeof valid === "string")
        return valid;
    const value = parseFloat(wr.value);
    if (value > max)
        return replace(exports.messages.maxValue, max);
    return true;
}
exports.valueNumberMax = valueNumberMax;
function valueNumberMin(wr, min) {
    const valid = valueIsNumber(wr);
    if (typeof valid === "string")
        return valid;
    const value = parseFloat(wr.value);
    if (value < min)
        return replace(exports.messages.minValue, min);
    return true;
}
exports.valueNumberMin = valueNumberMin;
function valueNumberInt(wr) {
    const valid = valueIsNumber(wr);
    if (typeof valid === "string")
        return valid;
    wr.value = wr.value.replace(/[^\d]/g, '');
    const value = parseInt(wr.value);
    if ((isNaN(value))) {
        return exports.messages.noIntNumber;
    }
    return true;
}
exports.valueNumberInt = valueNumberInt;
function valueNumberUInt(wr) {
    const valid = valueNumberInt(wr);
    if (typeof valid === "string")
        return valid;
    const value = parseInt(wr.value);
    if ((value < 0) || (isNaN(value))) {
        return exports.messages.noUIntNumber;
    }
    return true;
}
exports.valueNumberUInt = valueNumberUInt;
function valueNotNumber(wr) {
    const valid = valueIsNumber(wr);
    if (typeof valid === "boolean")
        return exports.messages.notOnlyNumber;
    return true;
}
exports.valueNotNumber = valueNotNumber;
function valueLength(wr, length) {
    const valid = valueRequired(wr);
    if (typeof valid === "string")
        return valid;
    if (typeof wr.value === "string") {
        if (wr.value.length !== length)
            return replace(exports.messages.fixCountChars, length);
    }
    if (Array.isArray(wr.value)) {
        if (wr.value.length !== length)
            return replace(exports.messages.fixCountElements, length);
    }
    return true;
}
exports.valueLength = valueLength;
function valueMinLength(wr, length) {
    const valid = valueRequired(wr);
    if (typeof valid === "string")
        return valid;
    if (typeof wr.value === "string") {
        if (wr.value.length < length)
            return replace(exports.messages.noLessChars, length);
    }
    if (Array.isArray(wr.value)) {
        if (wr.value.length < length)
            return replace(exports.messages.noLessElements, length);
    }
    return true;
}
exports.valueMinLength = valueMinLength;
function valueMaxLength(wr, length) {
    if (_noValue(wr))
        return true;
    if (typeof wr.value === "string") {
        if (wr.value.length > length)
            return replace(exports.messages.noMoreChars, length);
    }
    if (Array.isArray(wr.value)) {
        if (wr.value.length > length)
            return replace(exports.messages.noMoreElements, length);
    }
    return true;
}
exports.valueMaxLength = valueMaxLength;
function valueIsPhone(wr) {
    if (_noValue(wr))
        return true;
    if (!wr.value.match(exports.validPhoneReg)) {
        if (wr.value)
            wr.value = wr.value.replace(/[^\d]/g, '');
        return exports.messages.noPhone;
    }
    return true;
}
exports.valueIsPhone = valueIsPhone;
function valueIsEmail(wr) {
    if (_noValue(wr))
        return true;
    if (!wr.value.match(exports.validEmailReg)) {
        return exports.messages.noEmail;
    }
    return true;
}
exports.valueIsEmail = valueIsEmail;
function valueSame(wr, wrAnother) {
    if (wr.value !== wrAnother.value)
        return exports.messages.noSame;
    return true;
}
exports.valueSame = valueSame;
//# sourceMappingURL=validation.js.map